import { AccountInfo, IPublicClientApplication, AuthenticationResult } from '@azure/msal-browser';
// import { loginRequest } from '../authConfig';
import { apiRequest } from '../authConfig';

let msalInstance: IPublicClientApplication | null = null;

export const setMsalInstance = (instance: IPublicClientApplication) => {
  msalInstance = instance;
};

export const getAccessToken = async (): Promise<string | null> => {
  if (!msalInstance) return null;
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) return null;
  const account = accounts[0];
  try {
    // Use apiRequest.scopes to get an access token for the API
    const response = await msalInstance.acquireTokenSilent({
      ...apiRequest,
      account,
    });
    if (response.accessToken) {
      // DEBUG: Log the access token to the console for inspection
      console.log('[DEBUG] Access Token:', response.accessToken);
      // Optionally decode the JWT for easier inspection
      try {
        const base64Url = response.accessToken.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map(function(c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
        );
        console.log('[DEBUG] Decoded Access Token Claims:', JSON.parse(jsonPayload));
      } catch (decodeError) {
        console.warn('[DEBUG] Failed to decode access token', decodeError);
      }
    }
    return response.accessToken || null;
  } catch (error) {
    console.warn('Silent token acquisition failed, trying interactive', error);
    try {
      // Fallback to interactive token acquisition
      const response = await msalInstance.acquireTokenPopup(apiRequest);
      if (response.accessToken) {
        // DEBUG: Log the access token to the console for inspection
        console.log('[DEBUG] Access Token:', response.accessToken);
        // Optionally decode the JWT for easier inspection
        try {
          const base64Url = response.accessToken.split('.')[1];
          const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          const jsonPayload = decodeURIComponent(
            atob(base64)
              .split('')
              .map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
              })
              .join('')
          );
          console.log('[DEBUG] Decoded Access Token Claims:', JSON.parse(jsonPayload));
        } catch (decodeError) {
          console.warn('[DEBUG] Failed to decode access token', decodeError);
        }
      }
      return response.accessToken;
    } catch (interactiveError) {
      console.error('Interactive token acquisition failed', interactiveError);
      return null;
    }
  }
};



